var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"EnterAmount"},[_c('div',{staticClass:"EnterAmount_text"},[_vm._v("\n    输入金额(元）\n  ")]),_c('AmountPageIn',{attrs:{"textButton":"确认转入","getAmountNum":_vm.getAmountNum}}),_c('self-popup',{model:{value:(_vm.ShowPopupContent),callback:function ($$v) {_vm.ShowPopupContent=$$v},expression:"ShowPopupContent"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }